import angular from "angular";
import VehicleAPI from "./services/vehicles-api-service.service";
import AdminCreateDriveService from "./services/admin-create-drive-service";
import LoginService from "./services/login-service";
import FlashService from "./services/flash-service";
import UserService from "./services/user-service";
import AuthService from "./services/auth-service.service";
import CalendarService from "./services/calendar-service";
import DrivesFilterService from "./services/drives-filter-service";
import SchoolService from "./services/school-service";
import BatchCreateService from "./services/batch-create-drive-service";
import ExceptionHandler from "./services/exception-handler.factory";
import AuthInterceptor from "./interceptors/auth-interceptor.service";
import AdminTasksService from "./services/admin-tasks-service";
import store from "../../store";
import CreateOrderService from "../../app/admin/services/create-order-service";
import OrderDetailsService from "./services/order-details-service";
import PolicyService from "./services/policy-service";
import PoliciesStoreService from "./services/policies-store-service";
import OpenReplayService from "./services/open-replay-service";
import NavigationHistoryService from "./services/navigation-history-service";
import Stripe3DSService from "./services/stripe-3ds-service";

export const Services = angular
  .module("services", [])
  .service("VehicleAPI", VehicleAPI)
  .service("AdminCreateDriveService", AdminCreateDriveService)
  .service("LoginService", LoginService)
  .service("FlashService", FlashService)
  .service("UserService", UserService)
  .service("AuthService", AuthService)
  .service("CalendarService", CalendarService)
  .service("DrivesFilterService", DrivesFilterService)
  .service("SchoolService", SchoolService)
  .service("BatchCreateService", BatchCreateService)
  // .factory('$exceptionHandler', ExceptionHandler)

  .service("CreateOrderService", CreateOrderService)
  .service("AdminTasksService", AdminTasksService)
  .service("AuthInterceptor", AuthInterceptor)
  .service("VueStoreFactory", [() => store])
  .service("OrderDetailsService", OrderDetailsService)
  .service("PolicyService", PolicyService)
  .service("PoliciesStoreService", PoliciesStoreService)
  .service("OpenReplayService", OpenReplayService)
  .service("NavigationHistoryService", NavigationHistoryService)
  .service("Stripe3DSService", Stripe3DSService);
